<template>
  <div class="map-container">
    <div ref="map" class="google-map"></div>
  </div>
</template>

<script>

export default {
  props: {
    markersData: {
      type: Array,
      required: true,
    },
    zoom: {
      type: Number,
      default: 4,
    },
  },

  data() {
    return {
      map: null,
      markers: [],
      geocoder: null,
      infoWindow: null,
    };
  },

  watch: {
    markersData: {
      handler() {
        this.renderMarkers();
      },
      deep: true,
    },
  },

  mounted() {
    this.initMap();
  },

  methods: {
    initMap() {
      if (!window.google || !window.google.maps) {
        console.error('Google Maps API não carregada');
        return;
      }

      this.resetMap();

      this.renderMarkers();
    },
    resetMap() {
        this.map = new google.maps.Map(this.$refs.map, {
          center: { lat: -15.75, lng: -47.95 },
          zoom: this.zoom,
          mapId: process.env.VUE_APP_GOOGLE_MAP_ID,
          mapTypeId: google.maps.MapTypeId.ROADMAP,
        });

        this.geocoder = new google.maps.Geocoder();
        this.infoWindow = new google.maps.InfoWindow();
    },
    renderMarkers() {
      if (!this.map || !this.markersData.length) {
        this.resetMap();
        return;
      }

      google.maps.event.addListener(this.infoWindow, 'closeclick', () => {
        this.$emit('clickMarker', null);
      });

      this.markers.forEach(marker => marker.map = null);
      this.markers = [];

      const bounds = new google.maps.LatLngBounds();

      this.markersData.forEach((item) => {
        const position = new google.maps.LatLng(item.latitude, item.longitude);

        const pinColor = item.tem_agendamento ? '#4285F4' : '#DB4437';

        const pin = new google.maps.marker.PinElement({
          background: pinColor,
          borderColor: "#000",
          glyphColor: "#000",
          scale: 0.7,
        });

        const marker = new google.maps.marker.AdvancedMarkerElement({
          map: this.map,
          position,
          content: pin.element,
          gmpDraggable: false,
        });

        marker._addressKey = item;

        this.markers.push(marker);
        bounds.extend(position);

        marker.addListener("click", () => {
          this.openInfoWindow(marker);
          this.emitClickMarker(marker);
        });
      });

      this.map.fitBounds(bounds);
    },

    emitClickMarker(marker) {
      const address = marker._addressKey;

      this.$emit('clickMarker', address);
    },

    renderAddressDetails(address) {
      let qtVaccines = address.vacinas.map(vacina => vacina.adesao_quantidade).join(', ');

      if(address.vacinas.length > 1) {
        qtVaccines = '<br>' + address.vacinas.map(({vacina_nome_popular, adesao_quantidade}) => `
          <span>${vacina_nome_popular}: ${adesao_quantidade}</span>
        `)
        .join('</br>')
      }

      const fields = [
        { label: "Localidade", value: address.cidade },
        { label: "Empresa", value: `${address.nome_empresa} (${address.documento_formatado})` },
        { label: "Endereço", value: `${address.logradouro}, ${address.numero ?? 'S/N'}, ${address.bairro}, ${address.cidade}, ${address.uf}, ${address.cep}` },
        { label: "Tipo de vacinas aderidas", value: address.vacinas.map(vacina => vacina.vacina_nome_popular).join(', ') },
        { label: "Quantidade de doses aderidas", value: qtVaccines },
        { label: "Possui agendamento", value: address.tem_agendamento ? 'Sim' : 'Não' },
      ];

      const detailsHtml = fields
          .filter(field => field.value != null && field.value !== '')
          .map(field => `<p><strong>${field.label}:</strong> ${field.value}</p>`)
          .join('');

      return `
        <div>
          ${detailsHtml}
        </div>
      `;
    },

    openInfoWindow(marker) {
      const address = marker._addressKey;
      const content = this.renderAddressDetails(address);
      this.infoWindow.setContent(content);
      this.infoWindow.open(this.map, marker);
    }
  }
};
</script>

<style scoped>
.map-container {
  width: 100%;
  height: 500px;
  padding-bottom: 2rem;
}

.google-map {
  width: 100%;
  height: 100%;
}
</style>
